import {
  ITERABLE_NAME as NAME,
  ITERABLE_DISPLAY_NAME as DISPLAY_NAME,
} from '../../constants/Destinations';

const DIR_NAME = 'Iterable';

const CNameMapping = {
  [NAME]: NAME,
  Iterable: NAME,
  iterable: NAME,
};

export { NAME, CNameMapping, DISPLAY_NAME, DIR_NAME };
